import RequestAbstract from "../abstract";

export default class PublicCurrencyConversionRate extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-currency-conversion-rates";
    }

}
